import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "autocomplete-popup__on-focus-container q-row" }
const _hoisted_2 = {
  key: 0,
  class: "on-focus__queries-list q-col-md-3"
}

import PredefinedQueriesContainer from './PredefinedQueries/PredefinedQueriesContainer.vue'
import UserRecentQueriesContainer from './UserRecentQueries/UserRecentQueriesContainer.vue'
import PopularQueriesContainer from './PopularQueries/PopularQueriesContainer.vue'

import {inject} from "vue";
import PopularProductsContainer
  from "@/components/AutocompletePopup/OnFocus/PopularProducts/PopularProductsContainer.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'OnFocusContainer',
  setup(__props) {

const SmartSearchConfig = inject('SmartSearchConfig').value;

const popularQueriesEnabled = SmartSearchConfig?.onfocus?.popularQueries?.enabled

const {enabled, sections} = SmartSearchConfig?.onfocus?.predefinedQueries
const showPredefinedQueries = sections.length > 0 && enabled

const recentQueriesEnabled = SmartSearchConfig?.onfocus?.recentQueries?.enabled
const showQueriesSection = popularQueriesEnabled || showPredefinedQueries || recentQueriesEnabled



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(showQueriesSection))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_unref(recentQueriesEnabled))
            ? (_openBlock(), _createBlock(UserRecentQueriesContainer, { key: 0 }))
            : _createCommentVNode("", true),
          (_unref(popularQueriesEnabled))
            ? (_openBlock(), _createBlock(PopularQueriesContainer, { key: 1 }))
            : _createCommentVNode("", true),
          (_unref(showPredefinedQueries))
            ? (_openBlock(), _createBlock(PredefinedQueriesContainer, {
                key: 2,
                sections: _unref(sections)
              }, null, 8, ["sections"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(PopularProductsContainer)
  ]))
}
}

})